export const COMPANY_CONSTANTS = {
  COMPANY_NAME: "Chef's Farm",
  STREET_AND_NUMBER: "Ankerweg 18",
  ZIP_AND_CITY: "1041 AT Amsterdam",
  COUNTRY: "Nederland",
  KVK: "85226912",
  VAT: "NL863552948B01",
  WEBSITE_URL: "shop.chefsfarm.nl",
  WEBSITE_NAME: "Chef's Farm",
  EMAIL: "sales@chefsfarm.nl",
  PHONE: "+31 6 16092321",
};

export const GROWY_COMPANY_CONSTANTS = {
  COMPANY_NAME: "Growy Nederland BV",
  STREET_AND_NUMBER: "Ankerweg 18",
  ZIP_AND_CITY: "1041 AT Amsterdam",
  COUNTRY: "Nederland",
  KVK: "85226912",
  VAT: "NL863552948B01",
  WEBSITE_URL: "www.growy.nl",
  WEBSITE_NAME: "Growy",
  EMAIL: "sales@growy.nl",
  PHONE: "+31 6 16092321",
};

export const LOGO_SRC = "/img/logo.png";
export const GROWY_LOGO_SRC = "/img/logo-growy.png";
export const COMPANY_COUNTRY_CODE = "NL";
export const REGIONS = ["NL", "KW", "SG"];

// Helper function to get company info based on company code
export const getCompanyInfo = (companyCode) => {
  if (companyCode === GROWY) {
    return {
      constants: GROWY_COMPANY_CONSTANTS,
      logoSrc: GROWY_LOGO_SRC,
      logoAlt: "Growy logo",
    };
  }

  return {
    constants: COMPANY_CONSTANTS,
    logoSrc: LOGO_SRC,
    logoAlt: "Chefs Farm logo",
  };
};

export const GROWY = "GR";
export const CHEFS_FARM = "CF";

// Helper function to get company info for a specific country, with fallback to global constants
export const getCompanyInfoForCountry = (companyCode, countryData) => {
  const fallback = getCompanyInfo(companyCode);
  const countryCompany = countryData?.companies?.[companyCode];

  if (!countryCompany) return fallback;

  return {
    ...fallback,
    constants: {
      ...fallback.constants,
      ...(countryCompany.company?.name && { COMPANY_NAME: countryCompany.company.name }),
      ...(countryCompany.company?.street && { STREET_AND_NUMBER: countryCompany.company.street }),
      ...(countryCompany.company?.zipCity && { ZIP_AND_CITY: countryCompany.company.zipCity }),
      ...(countryCompany.company?.country && { COUNTRY: countryCompany.company.country }),
      ...(countryCompany.company?.kvk && { KVK: countryCompany.company.kvk }),
      ...(countryCompany.company?.vat && { VAT: countryCompany.company.vat }),
      ...(countryCompany.contact?.url && { WEBSITE_URL: countryCompany.contact.url }),
      ...(countryCompany.contact?.email && { EMAIL: countryCompany.contact.email }),
      ...(countryCompany.contact?.phone && { PHONE: countryCompany.contact.phone }),
    },
  };
};
